/**
 * Phase 3 of assets/handoffs/design_handoff_app_shell: the two settings
 * pages (Workspace / Account), each an ordinary page with a horizontal tab
 * strip. Replaces SettingsPageTemplate's vertical sidebar-swap nav
 * ("Considered — A", retired) for every page that adopts it.
 *
 * PageTemplate is rendered with no `title`, which skips its own header
 * entirely — the actual header and tabs here are the new AppShell
 * components, which bring their own padding. The new shell's content column
 * is a normal flex sibling of the sidebar, not fixed-position, so it needs
 * no `.page-wrapper` margin-left/padding-top offset (that class existed only
 * to clear the old shell's fixed sidebar/top bar).
 *
 * @param {string} title - "Workspace settings" or "Account settings", not
 *   the active tab's label (the tab is already highlighted)
 * @param {string=} subtitle
 * @param {Array<{key,label,to,badge?}>} tabs - see settingsTabs.js
 * @param {ReactNode} children
 */
import React from "react";
import PageTemplate from "../PageTemplate";
import PageHeader from "../AppShell/PageHeader/PageHeader";
import SettingsTabs from "../AppShell/SettingsTabs/SettingsTabs";
import styles from "./TabbedSettingsPage.module.scss";

const TabbedSettingsPage = ({ title, subtitle, tabs, children }) => {
  return (
    <PageTemplate>
      <PageHeader title={title} subtitle={subtitle} noDivider />
      <SettingsTabs tabs={tabs} />
      <div className={styles.body}>{children}</div>
    </PageTemplate>
  );
};

export default TabbedSettingsPage;
